import { BANNER_IMAGE } from "@/lib/site";
import { unsplash, unsplashSet } from "@/lib/img";

export const Banner = () => {
  return (
    <section
      data-testid="banner-section"
      className="relative h-[320px] md:h-[420px] overflow-hidden"
    >
      <img
        src={unsplash(BANNER_IMAGE, 1280)}
        srcSet={unsplashSet(BANNER_IMAGE, [768, 1280, 1920])}
        sizes="100vw"
        alt="Reinigungsfirma NZ Clean im Einsatz in Leonberg und Umgebung"
        width="1280"
        height="420"
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#0A192F]/70" />
      <div className="absolute inset-0 flex items-center">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 w-full">
          <p className="max-w-xl text-2xl md:text-3xl font-bold text-white leading-snug">
            Im Einsatz für Ihre Sauberkeit – zuverlässig, gründlich und flexibel.
          </p>
        </div>
      </div>
    </section>
  );
};
